


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VFields } from '@/models/v-fields';
import { StoreModel, Pdi, VehicleLocation } from '@/models/admin/store';
import { Base } from '@/components/common/base';
import { storeService, vehicleEvaluationService } from '@/shared';
import { IDialogOption } from '@/models/dialog';
import { ValidationRules } from '@/helper/enum';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    }
})
export default class VehicleEvaluationEditPage extends Base {
    public storeViewModel: any = {};
    public storeModel: StoreModel = {};

    public vehicleEvaluationModel: any = {};
    public selectedLocation: string = '';
    public form: any = {};
    public vehicleEvaluationUpdateFields: Array<VFields<any>> = [];
    public storeId: number = 0;
    public appointmentNumber: string = "";
    public appointmentId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public requestProgress: boolean = false;

    public callMethod(methodName): void {
        if (methodName === 'backToList') {
            this.$router.push({
                name: 'app.vehicleevaluation'
            });
        } else if (methodName === 'submit') {
            if (!this.form.$valid) {
                this.showAlert(
                    false,
                    this.$t('stores.vehicleLocations.alertInvalidForm')
                );
                this.resetMethodName(methodName);
                return;
            }
        }
        this.resetMethodName(methodName);
    }
    public resetMethodName(methodName): void {
        if (methodName !== '') {
            this.$emit('resetMethodName', methodName);
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({
            id: '0',
            type: 'button',
            title: this.$parent.$t('faxSend.btnBackToListTitle') as string,
            disabled: false,
            visible: true,
            class: 'btn',
            label: this.$parent.$t('faxSend.btnBackToList') as string,
            click: 'backToList',
            icon: 'fas fa-arrow-left',
        });
        this.$emit('updateToolBar', buttons);
    }

    public async mounted() {
        this.storeId = this.userSession.storeId;
        this.setFormFields();
        if (this.$route.params) {
            this.appointmentNumber = this.$route.params.appointmentNumber;
            this.appointmentId = Number(this.$route.params.id);
            await this.getVehicleEvaluationDetails(this.storeId, this.appointmentNumber, this.appointmentId);
        }

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
    }

    public setFormFields(): void {
        this.vehicleEvaluationUpdateFields = [
            {
                key: 'marketCheckValue',
                required: false,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'MarketCheck Value',
                    loading: false,
                    rules: [
                        v => this.required('MarketCheck Value', v)
                    ]
                },
            },
            {
                key: 'predictedPayoff',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Predicted Payoff',
                    loading: false,
                    rules: [
                        v => this.required('Predicted Payoff', v)
                    ]
                },
            },
            {
                key: 'equityPrediction',
                required: true,
                type: 'v-alynk-text-field',
                templateOptions: {
                    disabled: false,
                    required: true,
                    label: 'Equity Prediction',
                    loading: false,
                    rules: [
                        v => this.required('Equity Prediction', v)
                    ]
                },
            },
        ];
    }

    public validateDeviceName(): Vue & { validate: () => boolean } {
        return this.$refs.vehicleEvaluationEditForm as Vue & { validate: () => boolean };
    }

    public async updateVehicleEvaluationFields(): Promise<void> {
        if (this.validateDeviceName().validate()) {
            try {
                this.requestProgress = true;
                this.$emit('update:progress', this.requestProgress);
                await vehicleEvaluationService.updateVehicleEvaluationDetailAsync(
                    this.vehicleEvaluationModel.marketCheckValue,
                    this.vehicleEvaluationModel.predictedPayoff,
                    this.vehicleEvaluationModel.equityPrediction,
                    this.appointmentNumber,
                    this.storeId,
                    this.appointmentId
                );
                this.showAlert(true, "Vehicle Evalaution details have been updated successfully");
                this.$router
                    .push({
                        name: 'app.vehicleevaluation',
                    });

            } finally {
                this.requestProgress = false;
                this.$emit('update:progress', this.requestProgress);
            }
        }
    }

    public async getVehicleEvaluationDetails(storeId: number, appointmentNumber: string, id: number): Promise<void> {
        try {

            this.formlyShowSkeleton(this.vehicleEvaluationUpdateFields);
            this.requestProgress = true;
            this.$emit('update:progress', this.requestProgress);
            this.vehicleEvaluationModel = await vehicleEvaluationService.getVehicleEvaluationDetailByApptNoAsync(appointmentNumber, storeId, id);
        } finally {
            this.formlyHideSkeleton(this.vehicleEvaluationUpdateFields);
            this.requestProgress = false;
            this.$emit('update:progress', this.requestProgress);
        }
    }
}
